/**
 * Generate unique marker ID for a listing
 *
 * Uses a fallback chain to ensure every listing gets a unique ID:
 * 1. lotIdEncoded (preferred - most stable identifier)
 * 2. aliasEncoded (backup - URL-friendly identifier)
 * 3. uriMalone (second backup - legacy identifier)
 * 4. Coordinate-based ID (last resort - generated from lat/lon)
 *
 * @param listing - Listing with potential ID fields and geo coordinates
 * @returns Unique marker ID string
 */

import type { ExtendedListing } from '@/src/lib/api/endpoints/listing';

export function generateMarkerId(listing: ExtendedListing): string {
  const lotId = listing.lotIdEncoded;
  const aliasId = listing.aliasEncoded;
  const uriId = listing.uriMalone;

  const markerId =
    (lotId && String(lotId).trim()) ||
    (aliasId && String(aliasId).trim()) ||
    (uriId && String(uriId).trim()) ||
    `listing_${listing.geo!.lat.toFixed(6)}_${listing.geo!.lon.toFixed(6)}`;

  return markerId;
}
